import { connect } from 'react-redux';
import { dismissValidationBlock } from 'actions/validationBlock';
import ValidationBlockDialog from './index';

// App-global instance of the write-block dialog (FR-5.1). Mounted once inside the
// redux Provider (app-router); driven entirely by the validationBlock slice, which the
// axios interceptor populates on a blocked write. Acknowledging it dispatches DISMISS.
const mapStateToProps = state => ({
  visible: state.validationBlock ? state.validationBlock.visible : false,
  violations: state.validationBlock ? state.validationBlock.violations : []
});

const mapDispatchToProps = dispatch => ({
  onOk() {
    dispatch(dismissValidationBlock());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ValidationBlockDialog);
